<template>
  <div
    v-if="!patient.consent"
    class="ui info message">
    <i class="user icon"/>
    {{ $t('patientInfo.noConsent') }}
  </div>
  <segment v-else>
    <h3 class="ui dividing header">
      <i class="calendar alternate outline icon"/>
      <div class="content">
        {{ $t('patientInfo.monitoring' ) }}
        <div class="sub header">
          {{ $t('patientInfo.monitoringSub') }}
        </div>
      </div>
    </h3>

    <template>
      <div style="margin-bottom: 1em; display: flex; flex: 1;">
        <div
          class="ui primary fluid button"
          @click.prevent="generateMigraineImpactReportsOrCopyLink(currentLocale)"
          :class="{ disabled: generatingPDF}">
          <span v-if="(language===null || language===currentLocale) && generatingPDF===null"><i class="download icon"/> {{ $t('patientInfo.generate', { report: $t('patientInfo.impactReports') }) }}</span>
          <span v-if="generatingPDF===true"><i class="download icon"/> {{ $t('patientInfo.generating', { report: $t('patientInfo.impactReports') }) }}</span>
          <span v-if="generatingPDF===false"><i class="download icon"/> {{ $t('patientInfo.download', { report: $t('patientInfo.impactReports') }) }}</span>
        </div>
        <div
          class="ui fluid button"
          @click.prevent="fetchMigraineListingOrCopyLink(currentLocale)"
          :class="{ disabled: isFetchingMigraineListing || userHasNoMigraineListing }">
          <span v-if="isFetchingMigraineListing===null"><i class="download icon"/>{{ $t('patientInfo.download', { report: $t('patientInfo.migraineListing') }) }}</span>
          <span v-if="isFetchingMigraineListing===true"><i class="download icon"/> {{ $t('patientInfo.generating', { report: $t('patientInfo.migraineListing') }) }}</span>
          <span v-if="isFetchingMigraineListing===false && hasFetchedMigraineListing"><i class="download icon"/> {{ $t('patientInfo.download', { report: $t('patientInfo.migraineListing') }) }}</span>
        </div>
        <!-- <div
          class="ui primary button"
          @click.prevent="generateMigraineImpactReportsOrCopyLink('en')"
          :class="{ disabled: generatingPDF}">
          <span v-if="language===null || language==='de'"><i class="download icon"/> {{ $t('patientInfo.generate', { report: $t('patientInfo.impactReports') }) }}  (EN)</span>
          <span v-if="language==='en' && generatingPDF===true"><i class="download icon"/> {{ $t('patientInfo.generating', { report: $t('patientInfo.impactReports') }) }}  (EN)</span>
          <span v-if="language==='en' && generatingPDF===false"><i class="download icon"/> {{ $t('patientInfo.download', { report: $t('patientInfo.impactReports') }) }}  (EN)</span>
        </div> -->
        <!-- <div
          class="ui basic primary button"
          @click.prevent="generateMigraineImpactReportsOrCopyLink('de')"
          :class="{ disabled: generatingPDF}">
          <span v-if="language===null || language==='en'"><i class="download icon"/> {{ $t('patientInfo.generate', { report: $t('patientInfo.impactReports') }) }}  (DE)</span>
          <span v-if="language==='de' && generatingPDF===true"><i class="download icon"/> {{ $t('patientInfo.generating', { report: $t('patientInfo.impactReports') }) }}  (DE)</span>
          <span v-if="language==='de' && generatingPDF===false"><i class="download icon"/> {{ $t('patientInfo.download', { report: $t('patientInfo.impactReports') }) }}  (DE)</span>
        </div> -->
      </div>

      <div class="ui fluid styled accordion">
        <div class="active title">
          <h3 class="ui header">
            <!--<i class="dropdown icon"/>-->
            {{ $t('patientInfo.dailyActionsMigStatus') }}
          </h3>
        </div>
        <div
          class="active content"
          style="padding-bottom: 0.5rem;">
          <table
            class="ui very basic unstackable table">
            <thead>
              <tr class="center aligned">
                <th class="one wide">
                  {{ $t('programDay') }}
                </th>
                <th class="one wide">
                  {{ $t('patientInfo.migraineFree') }}
                </th>
                <th>
                  <div class="ui grid">
                    <div class="four wide column left aligned">
                      {{ $t('shortName') }}
                    </div>
                    <div class="twelve wide column right aligned">
                      {{ $t('legend') }}:&nbsp;
                      <span class="ui green compact icon label">
                        <i class="checkmark icon"/>
                        {{ $t('actions.completed') }}
                      </span>
                      <span class="ui red compact icon label">
                        <i class="warning icon"/>
                        {{ $t('actions.incomplete') }}
                      </span>
                      <span class="ui compact icon label">
                        <i class="question icon"/>
                        {{ $t('actions.notFilled') }}
                      </span>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(day, index) in dailyArray"
                :key="`day-${index + 1}`">
                <td class="center aligned">
                  {{ index + 1 }}
                </td>
                <td
                  v-if="migraineDaysArray.indexOf(day.timestamp) === -1"
                  class="positive center aligned">
                  <i class="green checkmark icon"/>
                </td>
                <td
                  v-else
                  class="negative center aligned">
                  <i class="red close icon"/>
                </td>
                <td>
                  <template v-for="(item, actionIndex) in getDailyActions(day.timestamp)">
                    <span
                      v-if="item.data.completionStatus === true"
                      :key="`daily-action-${actionIndex}`"
                      class="ui green compact icon label">
                      <i class="checkmark icon"/>
                      {{ getActionShortName(item.data.actionId) }}
                    </span>
                    <span
                      v-else-if="item.data.completionStatus === false"
                      :key="`daily-action-${actionIndex}`"
                      class="ui red compact icon label">
                      <i class="exclamation icon"/>
                      {{ getActionShortName(item.data.actionId) }}
                    </span>
                    <span
                      v-else
                      :key="`daily-action-${actionIndex}`"
                      class="ui compact icon label">
                      <i class="question icon"/>
                      {{ getActionShortName(item.data.actionId) }}
                    </span>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--<div class="title">-->
        <!--  <h3 class="ui header">-->
        <!--    <i class="dropdown icon"/>-->
        <!--    {{ $t('patientInfo.oneTimeActions') }}-->
        <!--  </h3>-->
        <!--</div>-->
        <!--<div class="content">-->
        <!--  <table-->
        <!--    class="ui very basic table">-->
        <!--    <thead>-->
        <!--      <tr>-->
        <!--        <th>-->
        <!--          {{ $tc('shortName') }}-->
        <!--        </th>-->
        <!--        <th>-->
        <!--          {{ $t('actions.dueDate') }}-->
        <!--        </th>-->
        <!--        <th>-->
        <!--          {{ $t('actions.completionStatus') }}-->
        <!--        </th>-->
        <!--      </tr>-->
        <!--    </thead>-->
        <!--    <tbody>-->
        <!--      <tr-->
        <!--        v-for="item in oneTimeEvents"-->
        <!--        :key="item.id">-->
        <!--        <td>-->
        <!--          {{ getActionShortName(item.data.actionId) }}-->
        <!--        </td>-->
        <!--        <td>-->
        <!--          {{ $d(new Date(item.endTimestamp), 'short') }}-->
        <!--        </td>-->
        <!--        <td>-->
        <!--          <i-->
        <!--            v-if="item.data.completionStatus === true"-->
        <!--            class="green checkmark icon"/>-->
        <!--          <i-->
        <!--            v-if="item.data.completionStatus === false"-->
        <!--            class="red close icon"/>-->
        <!--          <i-->
        <!--            v-else-->
        <!--            class="question icon"/>-->
        <!--        </td>-->
        <!--      </tr>-->
        <!--    </tbody>-->
        <!--  </table>-->
        <!--</div>-->
      </div>
    </template>

    <generate-p-d-f-modal
      @mir-modal-id="mirModalId = $event"
      @mir-error-modal-id="mirErrorModalId = $event"
      @retry-generate-mir="generateMIR"
      :generating-p-d-f="generatingPDF"
      :pdf-short-link="mirPdfShortLink"
      :pdf-long-link="mirPdfLongLink"
      :language="language"/>

    <fetch-migraine-listing-p-d-f-modal
      @migraine-listing-modal-id="migraineListingModalId = $event"
      @migraine-listing-error-modal-id="migraineListingErrorModalId = $event"
      @no-migraine-listing-modal-id="noMigraineListingModalId = $event"
      @retry-fetch-migraine-listing="fetchMigraineListing"
      :is-fetching-migraine-listing="isFetchingMigraineListing"
      :migraine-listing-pdf-link="migraineListingPdfLink"
      :migraine-listing-html-link="migraineListingHtmlLink"
      language="en"/>
      <!-- :language="language"/>-->
  </segment>
</template>

<script>

import GeneratePDFModal from './GeneratePDFModal'
import Segment from '../utility/Segment'
import FetchMigraineListingPDFModal from './FetchMigraineListingPDFModal'
import { addTimeDeltaToTimestamp } from '../../mixins/timestampManipulation'

export default {
  name: 'PatientMonitoring',
  components: { FetchMigraineListingPDFModal, Segment, GeneratePDFModal },
  props: {
    patient: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      migraineDaysArray: [],
      generatingPDF: null,
      mirPdfShortLink: null,
      mirPdfLongLink: null,
      isFetchingMigraineListing: null,
      migraineListingHtmlLink: null,
      migraineListingPdfLink: null,
      language: null,
      mirModalId: null,
      mirErrorModalId: null,
      migraineListingModalId: null,
      migraineListingErrorModalId: null,
      noMigraineListingModalId: null,
      userHasNoMigraineListing: null,
      timeout: 20000
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale.split('-')[0]
    },
    actionEvents () {
      return this.patient.userEvents.filter(event => event.type === 'action')
    },
    oneTimeEvents () {
      return this.actionEvents.filter(event => event.data.trackingType === 'once')
    },
    dailyTrackingEvents () {
      return this.actionEvents.filter(event => event.data.trackingType === 'daily')
    },
    dailyArray () {
      let output = []

      let startDate = this.patient.data.startDate

      if (this.patient.data.startDate === null) {
        return output
      }

      let currentDay = Math.floor((Date.now() - startDate) / 86400000) + 1

      for (let i = 0; i < currentDay; i++) {
        output.push({ timestamp: startDate + (86400000 * i) })
      }

      return output
    },
    reportTimePeriod () {
      let now = new Date()
      let startTime = this.patient.data.startDate
      let endTime = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())

      return {
        startTime: startTime,
        endTime: endTime
      }
    },
    generatedReportsTimePeriod () {
      // NOTE: New Logic for MIR and Migraine Listing: Show from 3 months before program enrollment date to day of request
      let now = new Date()
      let startTime = addTimeDeltaToTimestamp(this.patient.data.startDate, { days: -90 })
      let endTime = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1)

      return {
        startTime: startTime,
        endTime: endTime
      }
    },
    mirRequestURL () {
      return process.env.VUE_APP_PROGRAM_URL + '/patients/' + this.patient.userId + '/migraineDays?startTime=' + this.reportTimePeriod.startTime + '&endTime=' + this.reportTimePeriod.endTime
    },
    migraineListingRequestURL () {
      return process.env.VUE_APP_PROGRAM_URL + '/patients/' + this.patient.userId + '/migraineListingPDF?startTime=' + this.generatedReportsTimePeriod.startTime + '&endTime=' + this.generatedReportsTimePeriod.endTime + '&lang=' + this.language
    },
    hasFetchedMigraineListing () {
      return !!this.migraineListingHtmlLink && !!this.migraineListingPdfLink
    }
  },
  watch: {
    currentLocale (newVal, oldVal) {
      this.language = null
      this.generatingPDF = null
      this.isFetchingMigraineListing = null
    }
  },
  mounted () {
    // $('.ui.accordion').accordion()

    this.getMigraineDays()
  },
  methods: {
    getMigraineDays () {
      this.$axios.get(
        this.mirRequestURL,
        this.requestConfig
      ).then(
        ({ data }) => {
          let allDailyEvents = data.result.dailyEventsData
          let allMigDays = []

          if (allDailyEvents.hasOwnProperty('mig')) {
            Object.keys(allDailyEvents.mig).forEach((subtype) => {
              Object.keys(allDailyEvents.mig[subtype]).forEach((month) => {
                allDailyEvents.mig[subtype][month].forEach((UTCtimestamp) => {
                  allMigDays.push(UTCtimestamp)
                })
              })
            })
          }
          this.migraineDaysArray = [...allMigDays]
        },
        ({ response }) => {
          if (response.status !== 401) {
            this.$rollbar.error('Error in fetching Migraine Days', response)
          }
        }
      )
    },
    findAction (actionId) {
      return this.patient.userPlans.find(userPlan => userPlan.data.id === actionId)
    },
    getActionShortName (actionId) {
      let action = this.findAction(actionId)
      return action.data.title
    },
    getDailyActions (timestamp) {
      return (
        this.dailyTrackingEvents
          .filter(event => event.startTimestamp === timestamp)
      )
    },
    generateMigraineImpactReportsOrCopyLink (language) {
      if (this.language === language) {
        if (this.generatingPDF === null) {
          this.generateMIR()
        } else if (this.generatingPDF === false) {
          this.showModal(this.mirModalId)
        }
      } else if (this.language !== language) {
        this.language = language
        this.resetPDFGeneration()
        this.generateMIR()
      }
    },
    fetchMigraineListingOrCopyLink (language) {
      if (this.language === language) {
        if (this.isFetchingMigraineListing === null) {
          this.fetchMigraineListing()
        } else if (this.hasFetchedMigraineListing && this.isFetchingMigraineListing === false) {
          this.showModal(this.migraineListingModalId)
        }
      } else if (this.language !== language) {
        this.language = language
        this.resetMigraineListingFetch()
        this.fetchMigraineListing()
      }
    },
    resetPDFGeneration () {
      this.mirPdfShortLink = null
      this.mirPdfLongLink = null
      this.generatingPDF = null
    },
    resetMigraineListingFetch () {
      this.migraineListingPdfLink = null
      this.migraineListingHtmlLink = null
      this.isFetchingMigraineListing = null
    },
    showModal (modalId) {
      $('#' + modalId)
        .modal({ closable: false, autofocus: false, observeChanges: true, transition: 'fade' })
        .modal('show')
    },
    hideModal (modalId) {
      $('#' + modalId).modal('hide')
    },
    generateMIR () {
      return new Promise(
        (resolve, reject) => {
          this.generatingPDF = true
          this.showModal(this.mirModalId)

          let requestUrl = process.env.VUE_APP_PROGRAM_URL + '/hcp-pdf/' + this.patient.userId + '?waitForElement=false'

          // NOTE: Original Logic For MIR
          // let now = new Date()
          // let today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
          // let programEndDate = this.patient.data.endDate
          // let startTime = this.patient.data.startDate
          // let endTime
          //
          // switch (programEndDate) {
          //   case null:
          //     endTime = today
          //     break
          //   default:
          //     /*
          //       - If date now is smaller than or equal to program end date, then use date now
          //       - If date now is bigger than program end date, use program end date
          //       */
          //     endTime = today <= programEndDate ? today : programEndDate
          //     break
          // }
          //
          // let reportURL = process.env.VUE_APP_PRINT_URL + '?coachprogramid=' + process.env.VUE_APP_PROGRAM_ID + '&userAuthToken=' + encodeURIComponent(this.userAuthToken) + '&uid=' + this.patient.userId + '&startTime=' + startTime + '&endTime=' + endTime + '&country=' + country + '&lang=' + this.language + '&mode=coach#/print'

          let country = 'CH'

          let reportURL = process.env.VUE_APP_PRINT_URL + '?coachprogramid=' + process.env.VUE_APP_PROGRAM_ID + '&userAuthToken=' + encodeURIComponent(this.userAuthToken) + '&uid=' + this.patient.userId + '&startTime=' + this.generatedReportsTimePeriod.startTime + '&endTime=' + this.generatedReportsTimePeriod.endTime + '&country=' + country + '&lang=' + this.language + '&mode=coach#/print'

          this.$axios.get(
            requestUrl,
            {
              headers: {
                'Content-type': 'application/json',
                'accept': 'application/json',
                'x-auth-token': this.userAuthToken,
                'report-url': reportURL // FIXME: This will be the production MIR link of Migraine Impact Reports
              },
              timeout: this.timeout
            }
          ).then(
            ({ data }) => {
              this.mirPdfLongLink = data.result.longUrl
              this.mirPdfShortLink = data.result.shortUrl
              this.generatingPDF = false

              resolve()
            },
            ({ response }) => {
              setTimeout(
                () => {
                  this.hideModal(this.mirModalId)
                },
                1000
              )
              setTimeout(
                () => {
                  this.resetPDFGeneration()
                },
                2000
              )
              setTimeout(
                () => {
                  this.$rollbar.error(`Failed to generate MIR for \`userId\`: ${this.patient.userId}`, response)
                  this.showModal(this.mirErrorModalId)
                  reject(response)
                },
                2000
              )
            }
          )
        }
      ).catch(
        error => {
          this.$rollbar.error(`Request to generate MIR for user hit ${this.timeout} milliseconds timeout`, error)
        }
      )
    },
    fetchMigraineListing () {
      return new Promise(
        (resolve, reject) => {
          this.isFetchingMigraineListing = true
          this.showModal(this.migraineListingModalId)

          this.$axios.get(
            this.migraineListingRequestURL,
            this.requestConfig
          ).then(
            async ({ data }) => {
              const getMigraineListingLinks = () => new Promise(
                resolve => {
                  setTimeout(
                    () => {
                      let { links } = data.result || {}
                      let { PDF: pdfLink, HTML: htmlLink } = links || {}

                      this.migraineListingHtmlLink = htmlLink || null
                      this.migraineListingPdfLink = pdfLink || null

                      if (!this.migraineListingPdfLink) {
                        this.userHasNoMigraineListing = true
                        setTimeout(() => { this.isFetchingMigraineListing = null }, 500)
                      } else {
                        this.isFetchingMigraineListing = false
                      }
                      resolve()
                    },
                    100
                  )
                }
              )

              const hideMigraineListingModal = () => new Promise(
                resolve => {
                  setTimeout(
                    () => {
                      if (!this.migraineListingPdfLink) {
                        this.hideModal(this.migraineListingModalId)
                      }
                      resolve()
                    },
                    300
                  )
                }
              )

              const showNoMigraineListingModal = () => new Promise(
                resolve => {
                  if (!this.migraineListingPdfLink) {
                    setTimeout(
                      () => {
                        this.showModal(this.noMigraineListingModalId)
                        resolve()
                      },
                      1000
                    )
                  }
                }
              )

              await getMigraineListingLinks()
              await hideMigraineListingModal()
              await showNoMigraineListingModal()
            },
            ({ response }) => {
              setTimeout(
                () => {
                  this.hideModal(this.migraineListingModalId)
                },
                1000
              )
              setTimeout(
                () => {
                  this.resetMigraineListingFetch()
                },
                2000
              )
              setTimeout(
                () => {
                  this.$rollbar.error(`Failed to fetch Migraine Listing`, response)
                  this.showModal(this.migraineListingErrorModalId)
                  reject(response)
                },
                2000
              )
            }
          )
        }
      ).catch(
        error => {
          this.$rollbar.error(`Request to fetch Migraine Listing for user: hit ${this.timeout} milliseconds timeout`, error)
        }
      )
    }
  }
}
</script>

<style scoped>
td {
  height: 2.428571rem !important;
  padding: 0 !important;
}
.ui.icon.label {
  margin: 0.25rem !important;
}
/*
.ui.styled.accordion .content {
  padding: 1em;
  padding-left: 2em; */
/* } */
</style>
